import { log } from '@ecommerce/shared'
import config from '@ecommerce/shared/src/config'

export const mockConfig = {
  enabled: config.APP_USE_MOCK_API === 'true',

  payments: {
    shouldFail: false,
    delay: 800,
    otp: '1234',
    authPrefix: 'AUTH-',
  },
}

export const updateMockConfig = (newConfig: Partial<typeof mockConfig>) => {
  Object.assign(mockConfig, newConfig)
  log.info('🔶 Mock configuration updated:', mockConfig)
}
